// Fonte: UManutContas.dfm — Painel P6, Ds_Interna → tabela Contas_Internas
import React, { useState, useMemo } from 'react';
import { Form, Row, Col, Card, Collapse } from 'react-bootstrap';
import Select from 'react-select';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

var DEBITA_DESPESA = [
  { value: 'S', label: 'Sim' },
  { value: 'N', label: 'Não' },
];

// Limite de opções renderizadas no dropdown de Conta Crédito Projeto.
// Fonte: UManutContas.dfm:2334-2347 RxDBLookupCombo2 usa DropDownCount=8 + filtro incremental.
// LookupContasAtivas.sql não filtra por GE (paridade com UDMContas.dfm:3912) e pode retornar milhares de linhas.
var LIMITE_OPCOES_CONTA = 50;

var FormTipo6 = function(_ref) {
  var formik = _ref.formik;
  var modoEdicao = _ref.modoEdicao;
  var lookups = _ref.lookups;
  var lookupsLoading = _ref.lookupsLoading;

  var tiposInternos = (lookups && lookups.tiposInternos) ? lookups.tiposInternos : [];
  var contasAtivas = (lookups && lookups.contasAtivas) ? lookups.contasAtivas : [];

  var val = function(campo) {
    var v = formik.values['tipo6'] ? formik.values['tipo6'][campo] : undefined;
    return v !== null && v !== undefined ? v : '';
  };

  var handleChange = function(e) {
    formik.setFieldValue('tipo6.' + e.target.name, e.target.value);
  };

  var tipoSelecionado = val('tipo_interna');
  // Tipo 2 = projeto — exige Conta_Cred_Projeto
  var exigeContaProjeto = tipoSelecionado === 2 || tipoSelecionado === '2';

  var [aberto, setAberto] = useState(true);

  var [inputConta, setInputConta] = useState('');
  var contaSelecionada = contasAtivas.find(function(c) { return c.value === val('conta_cred_projeto'); }) || null;

  var opcoesConta = useMemo(function() {
    var q = (inputConta || '').trim().toLowerCase();
    if (q.length < 2) return [];
    var out = [];
    for (var i = 0; i < contasAtivas.length && out.length < LIMITE_OPCOES_CONTA; i++) {
      if (String(contasAtivas[i].label).toLowerCase().indexOf(q) !== -1) out.push(contasAtivas[i]);
    }
    return out;
  }, [inputConta, contasAtivas]);

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="py-2 contas-card-header" style={{ cursor: 'pointer' }} onClick={function() { setAberto(!aberto); }}>
        <div className="d-flex justify-content-between align-items-center">
          <strong>Dados do Tipo: Interna</strong>
          {aberto ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
        </div>
      </Card.Header>
      <Collapse in={aberto}>
        <div>
      <Card.Body>
        <Row>
          <Col md={3} className="mb-3">
            {/* Fonte: UManutContas.pas linha 3196 — Descricao_Conta := Apelido_Conta (sempre) */}
            <Form.Label className="small mb-1">Descrição</Form.Label>
            <Form.Control
              type="text" size="sm"
              value={formik.values.apelido_conta || ''}
              disabled readOnly
            />
            <Form.Text muted>Sincronizada com Apelido.</Form.Text>
          </Col>
          <Col md={3} className="mb-3">
            <Form.Label className="small mb-1">Tipo Interno *</Form.Label>
            <Select
              placeholder="Selecione..."
              options={tiposInternos}
              isLoading={lookupsLoading}
              value={tiposInternos.find(function(t) { return t.value === val('tipo_interna'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo6.tipo_interna', opt ? opt.value : '');
              }}
              isDisabled={!modoEdicao || lookupsLoading}
              noOptionsMessage={function() { return 'Nenhum tipo'; }}
            />
          </Col>
          {exigeContaProjeto && (
            <Col md={4} className="mb-3">
              <Form.Label className="small mb-1">Conta Crédito Projeto *</Form.Label>
              <Select
                placeholder="Digite para buscar..."
                options={opcoesConta}
                isLoading={lookupsLoading}
                value={contaSelecionada}
                inputValue={inputConta}
                onInputChange={function(v, meta) {
                  if (meta && (meta.action === 'input-change' || meta.action === 'set-value')) {
                    setInputConta(v);
                  }
                }}
                filterOption={null}
                onChange={function(opt) {
                  formik.setFieldValue('tipo6.conta_cred_projeto', opt ? opt.value : '');
                  setInputConta('');
                }}
                isDisabled={!modoEdicao || lookupsLoading}
                noOptionsMessage={function() {
                  return (inputConta && inputConta.trim().length >= 2)
                    ? 'Nenhuma conta'
                    : 'Digite ao menos 2 caracteres...';
                }}
              />
            </Col>
          )}
          <Col md={2} className="mb-3">
            <Form.Label className="small mb-1">Débita Despesa</Form.Label>
            <Select
              options={DEBITA_DESPESA}
              isClearable
              value={DEBITA_DESPESA.find(function(d) { return d.value === val('debita_despesa'); }) || null}
              onChange={function(opt) {
                formik.setFieldValue('tipo6.debita_despesa', opt ? opt.value : null);
              }}
              isDisabled={!modoEdicao}
            />
          </Col>
        </Row>
      </Card.Body>
        </div>
      </Collapse>
    </Card>
  );
};

export default FormTipo6;
